module.exports={
    logout  : "تسجيل خروج",
    my      :'لي',
    scqx    :'إزالة الإذن',
    qxgl    :'إدارة الإذن',
    qdzxzhm :'هل أنت متأكد أنك تريد تسجيل الخروج؟',
    qtxkh   :'الرجاء ملء رقم البطاقة',
    qd      :' أكّد ',
    qx      :' ألغى ',
    gb      :' غلق ',
    kh      :' رقم البطاقة ',
    kmewm   :' فتح رمز ثنائي الأبعاد ',
    dl      :' سجل ',
    name    :' اسم المستخدم ',
    qtxname :' يرجى ملء اسم المستخدم ',
    pwas    :' كلمة السر ',
    qtxpwas :' يرجى ملء كلمة المرور ',
    tj      :' قدم ',
    zczh    :' رقم التسجيل ',
    zc      :' التسجيل ',
    sjhm    :' رقم الجوال ',
    qtxsjhm :' يرجى ملء رقم الهاتف المحمول ',
    yzm     :' رمز التحقق ',
    qtxyzm  :' يرجى ملء رمز التحقق ',
    yyzhqqdl:' حساب موجود ، انتقل إلى تسجيل الدخول',
    hqyzm   :' الحصول على رمز التحقق ',
    zccg    :' النجاح في التسجيل',
    zcsb    :' فشل التسجيل ',
    fscg    :' إرسال بنجاح',
    fssb    :' فشل إرسال',
    yhycz   :' المستخدم موجود بالفعل',

    xgmm    : " تعديل كلمة المرور",
    zhmm    :' استرجاع كلمة السر',
    qrmm    :'استرجاع كلمة السر',
    zhyxmm  :" استرجاع كلمة السر",
    yxyzm   :' صندوق البريد رمز التحقق',
    hqyxyzm :'الحصول على رمز التحقق من البريد',
    zzmmyx  :' إعادة تعيين كلمة السر',
    lcmmbyc :' اثنين من كلمات السر لا تتطابق',
    xgcg    :' تعديل بنجاح ',
    xgsb    :' فشل التعديل',
    qtxyxyx  :' يرجى ملء صندوق بريد صالح',
    lsmhhq  :' الحصول على 60 ثانية ',
    hqyyyzmcg:'الحصول على صندوق البريد رمز التحقق بنجاح',
    zhmmbd  :' كلمة السر غير صحيحة'
}